/**
 * Created by idea on 20/03/2017.
 */
import { Injectable } from '@angular/core';
import { ApiIcheckService } from './ApiIcheck.service'
import { AngularFireDatabase } from 'angularfire2/database';
import { AngularFireAuth } from 'angularfire2/auth';
import { environment } from '../../../environments/environment'
import { Observable } from 'rxjs';
import {ReplaySubject} from 'rxjs/ReplaySubject';
import * as firebase from 'firebase';
import { Subject } from 'rxjs/Subject';

import 'rxjs/add/operator/take';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
var that;
@Injectable()
export class FireBaseService {
    // public profileImageUpdate$ = new BehaviorSubject<any>('123');
    // public currentMessage1 = this.profileImageUpdate$.asObservable();

    public profileImageUpdate$ = ''
    // profileImageUpdate$: Subject<any> = new Subject<any>();

    messaging = firebase.messaging()
    currentMessage = new BehaviorSubject(null)
    database = firebase.database();

    constructor(public afAuth: AngularFireAuth, private db: AngularFireDatabase, private httpIck: ApiIcheckService) {
        that = this;
    }
    // changeMessage(message) {

    //   this.profileImageUpdate$ = message;
    //   console.log("va",this.profileImageUpdate$);
    // }

    getLogin(token_firebase: any) {
        return this.afAuth.auth.signInWithCustomToken(token_firebase).then(dta => {
            //that.getPermission();
            if ('serviceWorker' in navigator && 'PushManager' in window) {
                navigator.serviceWorker.register('sw.js')
                    .then(function (swReg) {
                        that.messaging.useServiceWorker(swReg);
                        that.getPermission();
                    })
                    .catch(function (error) {
                        //console.error('Service Worker Error', error);
                        that.getPermission();
                    });
            } else {
                console.warn('Push messaging is not supported');
            }
        });
    }


    getPermission() {
        this.messaging.requestPermission()
            .then(() => {
                console.log('Notification permission granted.');
                return this.messaging.getToken();
            })
            .then(token => {
                this.db.object('/users/' + this.getIdUser() + '/notificationTokens/' + token).set(true);
            })
            .catch((err) => {
                console.log('Unable to get permission to notify.', err);
            });
    }
    receiveMessage() {
        this.messaging.onMessage((payload: any) => {
            //console.log("Message received. ", payload);
            //this.currentMessage.next(payload)
            if (payload.notification) {
                const notificationTitle = payload.notification.title;
                const notificationOptions = {
                    body: payload.notification.body,
                    icon: payload.notification.icon
                };
                navigator.serviceWorker.ready.then(function (serviceWorkerRegistration) {
                    serviceWorkerRegistration.showNotification(notificationTitle, notificationOptions);
                })


            }
        });
    }


    getIdRoomChat() {
        let user = JSON.parse(localStorage.getItem('User'));
        let idUser = 'i-' + user.owner_id;
        let idAdmin = 'i-1469083968959';
        let roomId = [idUser, idAdmin].sort().join('|');

        return roomId;

    }
    getIdUser() {
        let user = JSON.parse(localStorage.getItem('User'));
        let idUser = 'i-' + user.owner_id;
        // console.log(idUser);
        return idUser;
    }

    getChatList(limit) {
        return this.db.list('/room-messages/' + this.getIdRoomChat(), ref => ref.orderByChild('timestamp').limitToLast(limit)).valueChanges();


        // return this.db.list('/chat_data/u2u/'+this.getIdRoomChat()+'/messages', {
        //     query: {
        //         orderByChild: 'timestamp',
        //         limitToLast: limit
        //     }
        // });
    }
    loadmore(last, limit): Observable<any> {
        return this.db.list('/room-messages/' + this.getIdRoomChat(), ref => ref.orderByChild('timestamp').endAt(last).limitToLast(limit)).valueChanges();
    }

    getChatInfo() {
        // return this.db.object('/rooms-users/'+this.getIdUser()+'/'+this.getIdRoomChat());
        return this.db.object('/users/' + this.getIdUser()).valueChanges();
    }
    readed() {
        this.db.object('/users/' + this.getIdUser() + '/unreadRooms/' + this.getIdRoomChat()).remove();
    }



}



// WEBPACK FOOTER //
// /app/src/app/common/services/FireBase.service.ts